// extracted by mini-css-extract-plugin
export default {"indicator":"FppBId","hidden":"Ne9bXE","sparkle":"Zsr6Yb","eclipseAiDotPulse":"TRZmgC","shimmerText":"TP63AO","eclipseAiShimmer":"baGoad"};